import {getAttributeOrThrow, mediaLoader, qsaOptional, qsOptional} from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class InteractiveRichText extends UcoastEl {
	static htmlSelector = 'interactive-rich-text'
	hoverTriggers?: NodeListOf<HTMLElement>
	hoverMediaElements?: NodeListOf<HTMLElement>
	constructor() {
		super()
		this.hoverTriggers = qsaOptional('[data-uc-interactive-rich-text-trigger]', this)
		this.hoverMediaElements = qsaOptional(
			'[data-uc-interactive-rich-text-hover-media-element]',
			this
		)
	}

	override connectedCallback() {
		super.connectedCallback()
		this.hoverTriggers?.forEach((trigger) => {
			const handle = getAttributeOrThrow('data-uc-interactive-rich-text-trigger', trigger)
			const relatedMediaItem = qsOptional(
				`[data-uc-interactive-rich-text-hover-media-element="${handle}"]`,
				this
			)
			if (!relatedMediaItem) return
			trigger.addEventListener('mouseover', (_: Event) => {
				relatedMediaItem.classList.add('active')
				if (relatedMediaItem.tagName === 'UCOAST-VIDEO') {
					mediaLoader()
				}
			})
			trigger.addEventListener('mouseout', (_: Event) => {
				relatedMediaItem.classList.remove('active')
			})
		})
	}
}
